/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

// global css
import './index.scss';

import { I18nextProvider } from 'react-i18next';
import React from 'react';
import ReactDOM from 'react-dom/client';
import i18n from './i18n';
import reportWebVitals from './reportWebVitals';
import { ApplicationRoot } from './components/ApplicationRoot';
import { ServiceWorkerProvider } from './components/context/ServiceWorkerContext';

// remove this check to use the dummy endpoints with the production build
if (process.env.NODE_ENV === 'development') {
  const { worker } = require('./mocks/browser');
  worker.start();
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ServiceWorkerProvider>
      <I18nextProvider i18n={i18n}>
        <ApplicationRoot />
      </I18nextProvider>
    </ServiceWorkerProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
